<template>
  <!-- 我的订单 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">模板中心</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="content">
        <div class="title">模板中心</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 精选运价 -->
          <el-tab-pane label="精选运价/现舱市场" name="first">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="jxyjForm.template_name"
                placeholder="模板名称"
              ></el-input>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="jxyjdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi">重置</el-button>
                <el-button class="shaixuan" @click="shaixuan">筛选</el-button>
              </div>
            </div>
            <div class="add">
              <el-button @click="addDeatil" icon="el-icon-plus"
                >新建模板</el-button
              >
            </div>
            <!-- 表格 -->
            <el-table
              v-loading="loading"
              :data="jxyjTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="template_name" label="模板名称">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column label="模板状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.is_disable"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeStatus(scope.row)"
                    active-color="#0073F5"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button
                    class="bianji"
                    @click="bianji(scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <span class="gang">/</span>
                  <el-button
                    class="del"
                    @click="delTemplate(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="jxyjForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="jxyjtotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 现舱市场 -->
          <!-- <el-tab-pane label="现舱市场" name="second">
            <div class="yi">
              <el-input
                v-model="xcscForm.template_name"
                placeholder="模板名称"
              ></el-input>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="xcscdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi">重置</el-button>
                <el-button class="shaixuan" @click="shaixuan">筛选</el-button>
              </div>
            </div>
            <div class="add">
              <el-button @click="addDeatil" icon="el-icon-plus"
                >新建模板</el-button
              >
            </div>
            <el-table
              v-loading="loading"
              :data="xcscTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="template_name" label="模板名称">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column label="模板状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.is_disable"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeStatus(scope.row)"
                    active-color="#0073F5"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button
                    class="bianji"
                    @click="bianji(scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <span class="gang">/</span>
                  <el-button
                    class="del"
                    @click="delTemplate(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="xcscForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="xcsctotal"
            >
            </el-pagination>
          </el-tab-pane> -->
          <!-- 美加到门 -->
          <el-tab-pane label="美加到门" name="third">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="mjdmForm.template_name"
                placeholder="模板名称"
              ></el-input>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="mjdmdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <div class="btns">
                <el-button class="chongzhi" @click="chongzhi">重置</el-button>
                <el-button class="shaixuan" @click="shaixuan">筛选</el-button>
              </div>
            </div>
            <div class="add">
              <el-button @click="addDeatil" icon="el-icon-plus"
                >新建模板</el-button
              >
            </div>
            <!-- 表格 -->
            <el-table
              v-loading="loading"
              :data="mjdmTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="template_name" label="模板名称">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column label="模板状态">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.is_disable"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeStatus(scope.row)"
                    active-color="#0073F5"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button
                    class="bianji"
                    @click="bianji(scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <span class="gang">/</span>
                  <el-button
                    class="del"
                    @click="delTemplate(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="mjdmForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="mjdmtotal"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <Bottom />
  </div>
</template>
    
<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  userTemplateLists,
  userTemplateDelete,
  userTemplateOnline,
  mjdmTemplateLists,
  mjdmTemplateDel,
  mjdmTemplateDisable,
} from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      activeName: "first",
      date: "",
      jxyjForm: {
        type: "1",
        template_name: "",
        state_time: "",
        end_time: "",
        page_no: 1,
        page_size: 10,
      },
      jxyjdate:'',
      jxyjtotal:0,
      jxyjTableData:[],
      xcscForm: {
        type: "2",
        template_name: "",
        state_time: "",
        end_time: "",
        page_no: 1,
        page_size: 10,
      },
      xcscdate:'',
      xcsctotal:0,
      xcscTableData:[],
      mjdmForm: {
        template_name: "",
        state_time: "",
        end_time: "",
        page_no: 1,
        page_size: 10,
      },
      mjdmdate:'',
      mjdmtotal:0,
      mjdmTableData:[],
      headers: {
        token: localStorage.getItem("token"),
      },
      total: 0,
      loading:false,
    };
  },
  methods: {
    handleClick() {
      if (this.activeName == "first") {
        this.getTemplate(this.jxyjForm);
      } else if (this.activeName == "second") {
        this.getTemplate(this.xcscForm);
      } else if (this.activeName == "third") {
        this.getMjdmTemplate(this.mjdmdate);
      }
    },
    handleSizeChange(val) {
      if (this.activeName == "first") {
        this.jxyjForm.page_size=val
        this.getTemplate(this.jxyjForm);
      } else if (this.activeName == "second") {
        this.xcscForm.page_size=val
        this.getTemplate(this.xcscForm);
      } else if (this.activeName == "third") {
        this.mjdmForm.page_size=val
        this.getMjdmTemplate(this.mjdmForm);
      }
    },
    handleCurrentChange(val) {
        if (this.activeName == "first") {
            this.jxyjForm.page_no=val
            this.getTemplate(this.jxyjForm);
        } else if (this.activeName == "second") {
            this.xcscForm.page_no=val
            this.getTemplate(this.xcscForm);
        } else if (this.activeName == "third") {
            this.mjdmForm.page_no=val
            this.getMjdmTemplate(this.mjdmForm);
        }
    },
    addDeatil() {
      let param = {
        title: "新建",
        id: "",
      };
      let urlName = "FreightTemplate";
      if (this.activeName == "first") {
        urlName = "FreightTemplate";
      } else if (this.activeName == "second") {
        urlName = "FreightTemplate";
      } else if (this.activeName == "third") {
        urlName = "ToDoorTemplate";
      }
      this.$router.push({
        name: urlName,
        params: param,
      });
    },
    // 编辑
    bianji(e) {
      let param = {
        title: "编辑",
        id: e.id,
      };
      let urlName = "FreightTemplate";
      if (this.activeName == "first") {
        urlName = "FreightTemplate";
      } else if (this.activeName == "second") {
        urlName = "MarketTemplate";
      } else if (this.activeName == "third") {
        urlName = "ToDoorTemplate";
      }
      this.$router.push({
        name: urlName,
        params: param,
      });
    },
    // 模版列表
    async getTemplate(e) {
      this.loading = true
      const res = await userTemplateLists(e, this.headers);
      if(e.type==undefined){
        e.type='1'
      }
      if (res.code == 1) {
          this.loading = false
        if(e.type=='1'){
            this.jxyjTableData = res.data.lists;
            this.jxyjtotal = res.data.count;
        }else if(e.type=='2'){
            this.xcscTableData = res.data.lists;
            this.xcsctotal = res.data.count;
        }
      }
    },
    // 美加模版列表
    async getMjdmTemplate(e) {
      this.loading = true
      const res = await mjdmTemplateLists(e, this.headers);
      if (res.code == 1) {
        this.loading = false
        this.mjdmTableData = res.data.lists;
        this.mjdmtotal = res.data.count;
      }
    },
    // 重置
    chongzhi() {
      if (this.activeName == "first") {
        this.jxyjForm={
            type: "1",
            template_name: "",
            state_time: "",
            end_time: "",
            page_no: "1",
            page_size: "10",
        }
        this.getTemplate(this.jxyjForm);
      } else if (this.activeName == "second") {
        this.xcscForm= {
            type: "2",
            template_name: "",
            state_time: "",
            end_time: "",
            page_no: "1",
            page_size: "10",
        }
        this.getTemplate(this.xcscForm);
      } else if (this.activeName == "third") {
        this.mjdmForm={
            type: "1",
            template_name: "",
            state_time: "",
            end_time: "",
            page_no: "1",
            page_size: "10",
        }
        this.getMjdmTemplate(this.mjdmForm);
      }
    },
    // 筛选
    shaixuan() {
        if (this.activeName == "first") {
            if(this.jxyjdate.length>0){
                this.jxyjForm.state_time= this.jxyjdate[0]
                this.jxyjForm.end_time= this.jxyjdate[1]
            }
            this.getTemplate(this.jxyjForm);
        } else if (this.activeName == "second") {
            if(this.xcscdate.length>0){
                this.xcscForm.state_time= this.xcscdate[0]
                this.xcscForm.end_time= this.xcscdate[1]
            }
            this.getTemplate(this.xcscForm);
        } else if (this.activeName == "third") {
            if(this.mjdmdate.length>0){
                this.mjdmForm.state_time= this.mjdmdate[0]
                this.mjdmForm.end_time= this.mjdmdate[1]
            }
            this.getMjdmTemplate(this.mjdmForm);
        }
    },
    // 删除
    delTemplate(e) {
      let api = userTemplateDelete;
      if (this.activeName == "third") {
        api = mjdmTemplateDel;
      }
      this.$confirm("此操作将删除此模版, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await api(
              {
                id: e.id,
              },
              this.headers
            );
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              if (this.activeName == "third") {
                this.getMjdmTemplate(this.mjdmForm);
              } else {
                if(this.activeName=='first'){
                    this.getTemplate(this.jxyjForm);
                }else{
                    this.getTemplate(this.xcscForm);
                }
              }
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          } catch (error) {
            console.log(error, "失败");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 修改列表是否禁用状态
    async changeStatus(e) {
      let api = userTemplateOnline;
      if (this.activeName == "third") {
        api = mjdmTemplateDisable;
      }
      try {
        const res = await api(
          {
            id: e.id,
          },
          this.headers
        );
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "状态修改成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
  },
  mounted() {
    this.getTemplate(this.jxyjForm);
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.content {
  border-radius: 12px 12px 12px 12px;
  background: #fff;

  margin-bottom: 32px;

  padding: 32px;

  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 10px;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #0073f5; //选中
  }

  ::v-deep .el-tabs__item:hover {
    color: #0073f5; //hover
    // cursor: pointer;
  }
  // 普通字体颜色
  ::v-deep .el-tabs__item {
    color: #606260; //悬浮
    // cursor: pointer;
    font-size: 18px;
  }

  // 下划线颜色
  ::v-deep .el-tabs__active-bar {
    background-color: #0073f5;
  }

  .yi {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    margin-top: 4px;

    .btns {
      width: 360px;
      height: 40px;
      text-align: right;

      .chongzhi {
        width: 100px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        font-style: normal;
        text-transform: none;
      }

      .shaixuan {
        width: 100px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        font-style: normal;
        text-transform: none;
      }
    }

    :deep(.el-input) {
      width: 360px;
      height: 40px;
      margin-bottom: 16px;

      input {
        width: 360px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;

        border: 0;
      }
    }
    :deep(.el-date-editor) {
      width: 360px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      margin-bottom: 16px;

      .el-range-input {
        background: #f9f9f9;
      }
    }
  }

  .gang {
    color: #999999;
    font-size: 14px;
  }
  .bianji {
    color: #0073f5;
    font-size: 14px;
  }

  .del {
    font-size: 14px;
    color: #fe3300;
  }
  .el-pagination {
    text-align: right;
    margin-top: 80px;
  }

  .add {
    margin-bottom: 20px;
    .el-button {
      width: 108px;
      height: 40px;
      background: #edf6ff;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>